import _defineProperty from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _asyncToGenerator from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == typeof h && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(typeof e + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import PropTypes from 'prop-types';
import { Component } from 'react';
import Screens from '..';
import { API_ROOT_LIST } from '../../api/Constants';
import { casinoIdStatus } from '../../api/PlayerInfoConstants';
import InboxMessagesProvider from '../../components/InboxMessagesProvider';
import NotificationContext from '../../context/NotificationContext';
import useFeatureFlags from '../../hooks/useFeatureFlags';
import { EVENT_TYPES } from '../../lib/analytics/constants';
import SettingsTitleEnum from './utils/SettingsTitleEnum';
import SettingsScreensEnum from './utils/SettingsScreensEnum';
import audio from '../../utils/audio';
import { FE_LINK_GUEST_LOGIN, FE_LOCALIZATION } from '../../utils/featureFlags/constants';
import { AUTH_TYPES } from '../../utils/authFlow/constants';
import { getText, TEXT_KEY } from '../../utils/localization';
import QueryParamsProxy from '../../utils/queryParamProxy';
import RouteParamConstants from '../../utils/routeParamConstants';
import Logger from '../../lib/analytics/logger';
import ERROR_CODE from '../../utils/errorCodes';
import { handleActionsCommands } from '../../state/api/services/utils/handlerInterceptors';
import { getObjectValues } from '../../utils/object';
var Settings = /*#__PURE__*/function (_Component) {
  function Settings(props) {
    var _this;
    _classCallCheck(this, Settings);
    _this = _callSuper(this, Settings, [props]);
    _this.changeComponentHandler = function (settingsScreen) {
      _this.setState({
        settingsScreen: settingsScreen,
        showPopUp: false,
        popUpTitle: ''
      });
    };
    _this.onChangeComponentHandler = function (nextScreen) {
      audio.onClick();
      var history = Array.from(_this.state.history);
      history.push(nextScreen);
      _this.setState({
        settingsScreen: nextScreen,
        history: history,
        showPopUp: false,
        popUpTitle: ''
      });
    };
    _this.goBackHandler = function () {
      audio.onClick();
      var history = Array.from(_this.state.history);
      history.pop();
      var index = history.length - 1;
      var nextScreen = index > -1 && history[index] || SettingsScreensEnum.settings;
      _this.setState({
        settingsScreen: nextScreen,
        history: history,
        showPopUp: false,
        popUpTitle: ''
      });
    };
    _this.onShowPopUp = function (popUpTitle) {
      _this.setState({
        showPopUp: true,
        popUpTitle: popUpTitle
      });
    };
    _this.toggleSound = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var _this$props, setSoundSettings, music, soundEffects, toggleSoundResponse, eventPayload;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            audio.onClick();
            _this$props = _this.props, setSoundSettings = _this$props.setSoundSettings, music = _this$props.music;
            soundEffects = _this.state.soundEffects;
            _this.setState({
              soundEffects: !soundEffects
            });
            _context.prev = 4;
            _context.next = 7;
            return _this.props.getToggleSound();
          case 7:
            toggleSoundResponse = _context.sent;
            if (toggleSoundResponse) {
              eventPayload = {
                status: !soundEffects ? 1 : 0
              };
              Logger.sendEvent(EVENT_TYPES.SETTING_SOUND_EFFECTS_TOGGLE, eventPayload);
              setSoundSettings({
                soundEffects: !soundEffects,
                music: music
              });
            }
            _context.next = 15;
            break;
          case 11:
            _context.prev = 11;
            _context.t0 = _context["catch"](4);
            _this.setState({
              soundEffects: soundEffects
            });
            Logger.sendEvent(EVENT_TYPES.FRONTEND_ERROR, {
              error: JSON.stringify(_context.t0),
              code: ERROR_CODE.TOGGLE_SOUND_ERROR
            });
          case 15:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[4, 11]]);
    }));
    _this.toggleMusic = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
      var _this$props2, soundEffects, setSoundSettings, music, toggleMusicResponse, eventPayload;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            audio.onClick();
            _this$props2 = _this.props, soundEffects = _this$props2.soundEffects, setSoundSettings = _this$props2.setSoundSettings;
            music = _this.state.music;
            _this.setState({
              music: !music
            });
            _context2.prev = 4;
            _context2.next = 7;
            return _this.props.getToggleMusic();
          case 7:
            toggleMusicResponse = _context2.sent;
            if (toggleMusicResponse) {
              eventPayload = {
                status: !music ? 1 : 0
              };
              Logger.sendEvent(EVENT_TYPES.SETTING_AMBIENT_SOUND_TOGGLE, eventPayload);
              setSoundSettings({
                soundEffects: soundEffects,
                music: !music
              });
            }
            if (!music) {
              audio.playMusic('backgroundMusic', true);
            } else {
              audio.pauseMusic();
            }
            _context2.next = 16;
            break;
          case 12:
            _context2.prev = 12;
            _context2.t0 = _context2["catch"](4);
            _this.setState({
              music: music
            });
            Logger.sendEvent(EVENT_TYPES.FRONTEND_ERROR, {
              error: JSON.stringify(_context2.t0),
              code: ERROR_CODE.TOGGLE_MUSIC_ERROR
            });
          case 16:
          case "end":
            return _context2.stop();
        }
      }, _callee2, null, [[4, 12]]);
    }));
    _this.toggleEmailOptIn = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
      var emailOptIn, updatePlayerProfileResponse, _error$data, dismissModal, actions;
      return _regeneratorRuntime().wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            audio.onClick();
            emailOptIn = _this.state.emailOptIn;
            _this.setState({
              emailOptIn: !emailOptIn
            });
            _context3.prev = 3;
            _context3.next = 6;
            return _this.props.postUpdatePlayerProfile(emailOptIn);
          case 6:
            updatePlayerProfileResponse = _context3.sent;
            if (!updatePlayerProfileResponse.success) {
              _this.handleUpdatePlayerProfileError(null, updatePlayerProfileResponse.msg || getText(TEXT_KEY.DEFAULT_ERROR_MESSAGE));
              _this.setState({
                emailOptIn: emailOptIn
              });
            } else {
              Logger.sendEvent(EVENT_TYPES.SETTINGS_PROMO_EMAIL_TOGGLE, {
                status: !emailOptIn
              });
            }
            _context3.next = 16;
            break;
          case 10:
            _context3.prev = 10;
            _context3.t0 = _context3["catch"](3);
            dismissModal = _this.props.dismissModal;
            actions = _context3.t0 === null || _context3.t0 === void 0 || (_error$data = _context3.t0.data) === null || _error$data === void 0 ? void 0 : _error$data.actions;
            _this.setState({
              emailOptIn: emailOptIn
            });
            if (actions) {
              dismissModal();
              handleActionsCommands(getObjectValues(actions));
            } else {
              _this.handleUpdatePlayerProfileError(_context3.t0, getText(TEXT_KEY.DEFAULT_ERROR_MESSAGE));
            }
          case 16:
          case "end":
            return _context3.stop();
        }
      }, _callee3, null, [[3, 10]]);
    }));
    _this.logoutHandler = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
      var platformLogout;
      return _regeneratorRuntime().wrap(function _callee4$(_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            audio.onClick();
            platformLogout = _this.props.platformLogout;
            platformLogout(_this.sharedLogout, _this.props.casinoIdStatus);
          case 3:
          case "end":
            return _context4.stop();
        }
      }, _callee4);
    }));
    _this.sharedLogout = function () {
      audio.pauseMusic();
      _this.props.clearState();
      _this.props.clearApiQueryState();
      InboxMessagesProvider.resetInbox();
      QueryParamsProxy.setQueryParams({
        m: undefined
      });
      QueryParamsProxy.navigate(_this.props.navigation, Screens.Start);
    };
    _this._handleCheatMenuClick = function () {
      audio.onClick();
      QueryParamsProxy.setQueryParams(_defineProperty({}, RouteParamConstants.PARAM_MODAL, Screens.CheatMenu));
    };
    _this._setApiRoot = function (newRoot) {
      var setApiRootIndex = _this.props.setApiRootIndex;
      setApiRootIndex(newRoot);
      _this.context.addNotification({
        message: getText(TEXT_KEY.ENV_CHANGED),
        button: getText(TEXT_KEY.OK)
      });
      _this.sharedLogout();
    };
    _this.handleUpdatePlayerProfileError = function (error, msg) {
      _this.context.addNotification({
        message: msg,
        button: getText(TEXT_KEY.OK)
      });
      Logger.sendEvent(EVENT_TYPES.FRONTEND_ERROR, {
        error: error ? JSON.stringify(error) : msg,
        code: ERROR_CODE.UPDATE_PLAYER_PROFILE_ERROR
      });
    };
    _this.state = {
      settingsScreen: SettingsScreensEnum.settings,
      history: [SettingsScreensEnum.settings],
      casinoId: null,
      email: null,
      emailOptIn: props.playerInfo.emailOptIn,
      soundEffects: props.soundEffects,
      music: props.music,
      playerName: null,
      showPopUp: false,
      popUpTitle: ''
    };
    _this.state.settingsScreen = QueryParamsProxy.findParam(RouteParamConstants.PARAM_SETTINGS_SCREEN, SettingsScreensEnum.settings);
    return _this;
  }
  _inherits(Settings, _Component);
  return _createClass(Settings, [{
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.props.setModal(null);
    }
  }, {
    key: "render",
    value: function render() {
      var _useFeatureFlags = useFeatureFlags(),
        hasFeature = _useFeatureFlags.hasFeature;
      var isLinkGuestAccountEnabled = hasFeature(FE_LINK_GUEST_LOGIN);
      var isLocalizationEnabled = hasFeature(FE_LOCALIZATION);
      var _this$state = this.state,
        settingsScreen = _this$state.settingsScreen,
        prevScreen = _this$state.prevScreen,
        environment = _this$state.environment;
      var _this$props$playerInf = this.props.playerInfo,
        playerName = _this$props$playerInf.name,
        casinoId = _this$props$playerInf.casinoId,
        email = _this$props$playerInf.email;
      var _this$props3 = this.props,
        playerId = _this$props3.playerId,
        propsCasinoIdStatus = _this$props3.casinoIdStatus,
        propertyName = _this$props3.propertyName,
        isDevUser = _this$props3.isDevUser,
        apiRootIndex = _this$props3.apiRootIndex,
        formInfo = _this$props3.formInfo,
        setFormInfo = _this$props3.setFormInfo,
        render = _this$props3.render,
        lastLoginInfo = _this$props3.lastLoginInfo,
        _this$props3$assetsUr = _this$props3.assetsUrls,
        termsAndConditions = _this$props3$assetsUr.termsAndConditions,
        privacyPolicy = _this$props3$assetsUr.privacyPolicy;
      var showCheatMenu = isDevUser;
      var isGuest = propsCasinoIdStatus === casinoIdStatus.GUEST || (lastLoginInfo === null || lastLoginInfo === void 0 ? void 0 : lastLoginInfo.loginMethod) === AUTH_TYPES.GUEST;
      return render({
        playerId: playerId,
        verifiedAccount: propsCasinoIdStatus === casinoIdStatus.PHYSICALLY_VERIFIED || propsCasinoIdStatus === casinoIdStatus.DIGITALLY_VERIFIED,
        isGuest: isGuest,
        playerName: playerName,
        casinoId: casinoId,
        email: email,
        emailOptIn: this.state.emailOptIn,
        propertyName: propertyName,
        soundEffects: this.state.soundEffects,
        music: this.state.music,
        logoutHandle: this.logoutHandler,
        toggleSound: this.toggleSound,
        toggleMusic: this.toggleMusic,
        toggleEmailOptIn: this.toggleEmailOptIn,
        changeComponentHandler: this.changeComponentHandler,
        onChangeComponentHandler: this.onChangeComponentHandler,
        goBackHandler: this.goBackHandler,
        clearUserData: this.sharedLogout,
        settingsScreen: settingsScreen,
        prevScreen: prevScreen,
        apiRootList: API_ROOT_LIST,
        apiRootIndex: apiRootIndex,
        setApiRootIndex: this._setApiRoot,
        formInfo: formInfo,
        setFormInfo: setFormInfo,
        propsCasinoIdStatus: propsCasinoIdStatus,
        titleEnum: SettingsTitleEnum(),
        screensEnum: SettingsScreensEnum,
        onShowPopUp: this.onShowPopUp,
        showPopUp: this.state.showPopUp,
        popUpTitle: this.state.popUpTitle,
        showCheatMenu: showCheatMenu,
        onClickCheatMenu: this._handleCheatMenuClick,
        privacyPolicy: privacyPolicy,
        termsAndConditions: termsAndConditions,
        environment: environment,
        lastLoginInfo: lastLoginInfo,
        isLinkGuestAccountEnabled: isLinkGuestAccountEnabled,
        isLocalizationEnabled: isLocalizationEnabled
      });
    }
  }]);
}(Component);
Settings.contextType = NotificationContext;
export { Settings as default };
Settings.propTypes = {
  soundEffects: PropTypes.any.isRequired,
  setSoundSettings: PropTypes.any.isRequired,
  music: PropTypes.any.isRequired,
  clearToken: PropTypes.any.isRequired,
  navigation: PropTypes.any.isRequired,
  platformLogout: PropTypes.any.isRequired,
  setApiRootIndex: PropTypes.any,
  render: PropTypes.any.isRequired,
  playerId: PropTypes.any.isRequired,
  casinoIdStatus: PropTypes.any.isRequired,
  propertyName: PropTypes.any.isRequired,
  apiRootIndex: PropTypes.any.isRequired,
  formInfo: PropTypes.any.isRequired,
  setFormInfo: PropTypes.any.isRequired
};